// extracted by mini-css-extract-plugin
export default {"Prose":"PageLegalDisclosure_Prose__binAI","ImpressumBlock":"PageLegalDisclosure_ImpressumBlock__KIM0O","Generator":"PageLegalDisclosure_Generator__dFNRQ"};